<script>
import EggStockBalance from '@/sales/components/EggStockBalance.vue';
import EggAverageProduction from '@/sales/components/EggAverageProduction.vue';

export default {
  components: {
    EggStockBalance,
    EggAverageProduction,
  },
}
</script>

<template>
  <div>
    <egg-stock-balance />
    <egg-average-production />
  </div>
</template>



// WEBPACK FOOTER //
// src/sales/views/StockView.vue